import { Controller } from '@hotwired/stimulus';
import * as bootstrap from 'bootstrap';

export default class extends Controller {
  static targets = ['modal'];

  static values = { confirmRequired: Boolean };

  toggleConfirmation({ detail }) {
    this.confirmRequiredValue = detail.signing;
  }

  exit(event) {
    if (!this.confirmRequiredValue) return;

    event.preventDefault();
    bootstrap.Modal.getOrCreateInstance(this.modalTarget).show();
  }
}
